import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import {startLoadingSpinner, stopLoadingSpinner} from "../../csf-ufc-pivotal/includes/utils";
import CsfMembreUtils from "../utils/CsfMembreUtils";
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import PivotalApiEnvironments
  from "../../../js/csf/pivotal/PivotalApiEnvironments";

class CsfMemberActivitiesDataLayer {

  static SEARCH_CURRENT_ACTIVITIES_FORM = 'CSF_EM_Current_Attendance';
  static SEARCH_FORMER_ACTIVITIES_FORM = 'CSF_EM_Former_Attendance';
  static CREATE_OR_UPDATE_FORM = 'CSF_EM_Attendance_REST';
  static GET_SPECIFIC_ACTIVITY = 'CSF_EM_Attendance_Info';
  static DELETE_FORM = 'CSF_EM_Attendance_DELETE';
  static SEARCH_ACTIVITY = "EM_Activity";
  static SEARCH_ACTIVITY_RESULT_LIST = "CSF_EM_Activity_SRL";
  static SEARCH_ACTIVITY_UFC = "CSF_EM_Activity_UFC";
  static SEARCH_ACTIVITY_UFC_RESULT_LIST = "CSF_EM_Activity_UFC_SRL";

  constructor(apiUrl, apiEnv, accessToken) {
    this.accessToken = accessToken;
    this.apiUrl = apiUrl;
    this.apiEnv = apiEnv;
    this.isInit = true;
  }

  getCurrentActivities(recordId, setActivitiesCallback, setErrorCallback){
    const requestData = {
      form: CsfMemberActivitiesDataLayer.SEARCH_CURRENT_ACTIVITIES_FORM,
      RecordId: recordId,
    };

    this.#getActivities(requestData, setActivitiesCallback, setErrorCallback);
  }

  getFormerActivities(recordId, setActivitiesCallback, setErrorCallback) {
    const requestData = {
      form: CsfMemberActivitiesDataLayer.SEARCH_FORMER_ACTIVITIES_FORM,
      RecordId: recordId,
    };

    this.#getActivities(requestData, setActivitiesCallback, setErrorCallback, false);
  }

  #getActivities(requestData, setActivitiesCallback, setErrorCallback, currentActivity = true) {
    const pivotalSearchApi = new PivotalFormApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalSearchApi.callFormRecuperationEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(async response => {
        if (response?.success && !CsfMembreUtils.objectIsEmpty(response?.payload?.data?.primary)) {

          setErrorCallback(false);

          let activities = currentActivity
            ? response.payload.data.primary?.Current_Periode__Secondary
            : response.payload.data.primary?.Former_Periode__Secondary;

            const updatedActivities = await Promise.all(
              activities.map(async (activity) => {
                const activityCourseData = await this.getActivityCourse(activity);
                return {
                  ...activity,
                  activityCourses: activityCourseData?.Attendance_Segment__Secondary[0],
                };
              })
            );
            setActivitiesCallback(updatedActivities);
        } else {
          setErrorCallback(true);
          console.error(error);
        }
      })
      .catch(error => {
        setErrorCallback(true);
        console.error(error);
      });
  }

  getActivity(recognitionNumber, activityDate, setErrorCallback) {

    return new Promise((resolve, reject) => {
      const requestData = {
        Search: CsfMemberActivitiesDataLayer.SEARCH_ACTIVITY,
        searchResultList: CsfMemberActivitiesDataLayer.SEARCH_ACTIVITY_RESULT_LIST,
        ParameterValues: [
          recognitionNumber,
          activityDate,
          activityDate,
        ]
      };

      const pivotalSearchApi = new PivotalSearchApi(this.apiUrl, this.apiEnv, this.accessToken);
      pivotalSearchApi.callSearchEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
        .then(response => {
          if (response?.success && response?.payload?.data?.rows?.length > 0) {
            setErrorCallback(false);
            resolve(response.payload.data.rows[0]);
          } else {
            setErrorCallback(true);
            console.error('Error fetching activity');
          }
        })
        .catch(error => {
          setErrorCallback(true);
          reject(new Error('Error fetching activity'));
        });
    })
  }

  getActivityUfc(recognitionNumber, activityDate, setErrorCallback) {
    return new Promise((resolve, reject) => {
      const requestData = {
        Search: CsfMemberActivitiesDataLayer.SEARCH_ACTIVITY_UFC,
        searchResultList: CsfMemberActivitiesDataLayer.SEARCH_ACTIVITY_UFC_RESULT_LIST,
        ParameterValues: [
          recognitionNumber,
          activityDate,
          activityDate,
        ]
      };
      const pivotalSearchApi = new PivotalSearchApi(this.apiUrl, this.apiEnv, this.accessToken);
      pivotalSearchApi.callSearchEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
        .then(response => {
          if (response?.success && response?.payload?.data?.rows?.length > 0) {
            setErrorCallback(false);
            resolve(response.payload.data.rows[0]);
          } else {
            setErrorCallback(true);
            console.error('Error fetching activity ufc');
          }
        })
        .catch(error => {
          setErrorCallback(true);
          console.error(error);
        });
    })
  }

  async createOrUpdateActivity(activity, ufcCase, recognitionNumber, activityDate, setErrorCallback, dismissButton) {
    startLoadingSpinner();
    const updatedActivity = await this.getActivity(recognitionNumber, activityDate, setErrorCallback);

    const requestData = {
      form: CsfMemberActivitiesDataLayer.CREATE_OR_UPDATE_FORM,
      RecordId: activity?.GSFT_Attendance_View_Id ?? "",
      deltaData: {
        Education_File_Id: ufcCase?.Education_File__Secondary[0]?.Education_File_Id ?? "",
        REDU_Activity_Id: updatedActivity?.REDU_Activity_Id ?? "",
        Follow_Up_On: activityDate,
      }
    };

    const pivotalFormApi = new PivotalFormApi(this.apiUrl, this.apiEnv, this.accessToken);

    const response = await pivotalFormApi.callFormPutEndpoint(
      requestData,
      PivotalApiEnvironments.getEspaceMembreSuffix()
    );

    if (response?.success) {
      stopLoadingSpinner();
      setErrorCallback(false);
      // If on activity page, refresh the page - prevents refreshing for nothing when using side menu btn (T5537-4869)
      if (document.getElementById('CsfMembreActivities')) {
        window.location.reload();
      } else {
        // Close modal
        dismissButton.current.click();
      }
    } else {
      setErrorCallback(true);
      console.error('Error in createOrUpdateActivity:');
      stopLoadingSpinner();
    }
  }

  deleteActivity(recognitionNumber, setErrorCallback) {
    const requestData = {
      form: CsfMemberActivitiesDataLayer.DELETE_FORM,
      recordId: recognitionNumber,
    }

    const pivotalFormApi = new PivotalFormApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalFormApi.callFormDeleteEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          stopLoadingSpinner();
        }
        setErrorCallback(false);
      })
      .catch(error => {
        setErrorCallback(true);
        console.error(error);
        stopLoadingSpinner();
      });
  }

  async getActivityCourse(selectedActivity) {
    const requestData = {
      form: CsfMemberActivitiesDataLayer.GET_SPECIFIC_ACTIVITY,
      RecordId: selectedActivity?.GSFT_Attendance_View_Id,
    };

    const pivotalFormApi = new PivotalFormApi(this.apiUrl, this.apiEnv, this.accessToken);

    try {
      const response = await pivotalFormApi.callFormRecuperationEndpoint(
        requestData,
        PivotalApiEnvironments.getEspaceMembreSuffix()
      );

      if (response?.success && !CsfMembreUtils.objectIsEmpty(response?.payload?.data?.primary)) {
        return response.payload.data.primary;
      }

      return {};
    } catch (error) {
      console.error(error);
      return {};
    }
  }
}

export default CsfMemberActivitiesDataLayer;
